export default "assets/images/menu-icon-mask-025987a2.svg";